<template lang="pug">
.container-menu-criterios
    .bloco-menu-criterios
        menu
            li(
                v-for='item in itensMenuCriterios',
                :class='criterioSelecionado?.id === item?.id ? "active" : "inactive"',
                @click='changeCriterio(item)'
            )
                i.mdi(:class='item.icone')
                span {{ getTranslation(item.sigla) }}
    .bloco-ranking
        el-card
            .bloco-ranking__cabecalho-grafico(:key='keyInfo')
                .criterio-selecionado
                    label {{ this.getTranslation(this.criterioSelecionado?.nome) }}
                .tipos-volume-area
                    el-select(
                        v-model='tipoVolumeSelecionado',
                        value-key='id',
                        @change='getRankingVolumePorCriterio'
                    )
                        el-option(
                            v-for='tipoVolume in tiposVolume',
                            :key='tipoVolume.id',
                            :label='getTranslation(tipoVolume.nome)',
                            :value='tipoVolume'
                        )
            .bloco-ranking__grafico
                #chart(v-loading='loadingData')
</template>

<script>
import DashboardRastreabilidadeServiceEmpresa from '@/services/DashboardRastreabilidadeServiceEmpresa';
import * as ApexCharts from 'apexcharts';

import { mapState } from 'vuex';

export default {
    name: 'RankingVolumeOriginadoPorCriterio',
    data() {
        return {
            chartOptions: {
                series: [],
                chart: {
                    type: 'bar',
                    height: 350
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                        barHeight: 30
                    }
                },
                colors: ['#043C5A'],
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: []
                },
                noData: {
                    text: this.$t(
                        'mensagens.rastreabilidadeEmpresa.dashboard.ranking.semDados'
                    )
                }
            },
            itensMenuCriterios: [
                {
                    id: 1,
                    nome: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.fornecedores',
                    codigo: 'FORNECEDOR_PARCEIRO',
                    sigla: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.siglas.fornecedores',
                    icone: 'mdi-van-utility'
                },
                {
                    id: 2,
                    nome: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.estados',
                    codigo: 'ESTADO',
                    sigla: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.siglas.estados',
                    icone: 'mdi-map-outline'
                },
                {
                    id: 3,
                    nome: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.gerentesRegionais',
                    codigo: 'GERENTE_REGIONAL',
                    sigla: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.siglas.gerentesRegionais',
                    icone: 'mdi-account-outline'
                },
                {
                    id: 4,
                    nome: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.gerentesComerciais',
                    codigo: 'GERENTE_COMERCIAL',
                    sigla: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.siglas.gerentesComerciais',
                    icone: 'mdi-account-multiple'
                },
                {
                    id: 5,
                    nome: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.gestoresTerritoriais',
                    codigo: 'GESTOR_TERRITORIAL',
                    sigla: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.siglas.gestoresTerritoriais',
                    icone: 'mdi-account-group-outline'
                },
                {
                    id: 6,
                    nome: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.regionais',
                    codigo: 'REGIONAL',
                    sigla: 'mensagens.rastreabilidadeEmpresa.dashboard.ranking.siglas.regionais',
                    icone: 'mdi-home-variant-outline'
                }
            ],
            tiposVolume: [
                {
                    id: 1,
                    nome: 'mensagens.rastreabilidadeEmpresa.rastreavel',
                    codigo: 'RASTREAVEL'
                },
                {
                    id: 2,
                    nome: 'mensagens.rastreabilidadeEmpresa.emAndamento',
                    codigo: 'EM_ANDAMENTO'
                },
                {
                    id: 3,
                    nome: 'mensagens.rastreabilidadeEmpresa.naoRastreavel',
                    codigo: 'NAO_RASTREAVEL'
                }
            ],
            loadingData: false,
            criterioSelecionado: null,
            tipoVolumeSelecionado: null,
            keyInfo: 0
        };
    },
    watch: {
        '$i18n.locale': function () {
            this.getRankingVolumePorCriterio();
            this.keyInfo = this.keyInfo + 1;
        }
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    mounted() {
        this.setDefaultCriterio();
        this.setDefaultTipoVolume();
        this.getRankingVolumePorCriterio();

        if (this.usuarioLogado.ambienteLogado === 'PY') {
            this.itensMenuCriterios = this.itensMenuCriterios.filter(
                item => item.id < 3
            );
        }
    },
    methods: {
        getTranslation(code) {
            return this.$t(code);
        },
        setDefaultCriterio() {
            this.criterioSelecionado = this.itensMenuCriterios[0];
        },
        setDefaultTipoVolume() {
            this.tipoVolumeSelecionado = this.tiposVolume[0];
        },
        changeCriterio(criterio) {
            if (criterio) {
                this.criterioSelecionado = criterio;
                this.getRankingVolumePorCriterio();
            }
        },
        async getRankingVolumePorCriterio() {
            if (
                this.tipoVolumeSelecionado &&
                this.tipoVolumeSelecionado.codigo &&
                this.criterioSelecionado &&
                this.criterioSelecionado.codigo
            ) {
                this.loadingData = true;
                try {
                    const { data } =
                        await DashboardRastreabilidadeServiceEmpresa.getRankingVolumePorCriterio(
                            {
                                tipoVolume: this.tipoVolumeSelecionado.codigo,
                                tipoCriterio: this.criterioSelecionado.codigo
                            }
                        );

                    this.atualizarGrafico(data);
                } catch {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.dashboard.ranking.erroBuscarDados'
                        )
                    );
                }
                this.loadingData = false;
            }
        },
        async atualizarGrafico(dados) {
            const data = [];
            const categories = [];

            dados.forEach((dado, index) => {
                let valor = Number(dado.value) / 1000;
                let valorLimitadoCasasDecimais = valor.toFixed(3);
                //                let valorLimitadoCasasDecimais = Number.isInteger(Number(dado.value)) ? Number(dado.value).toLocaleString('pt-BR') : Number(dado.value).toLocaleString('pt-BR', { minimumFractionDigits: 3 });
                data.push(valorLimitadoCasasDecimais);
                categories.push(
                    `${index + 1}º ${this.buscaTraducao(dado.label)}`
                );
            });
            this.chartOptions.xaxis.categories = categories;

            const chart = new ApexCharts(
                document.querySelector('#chart'),
                this.chartOptions
            );
            chart.render();
            chart.updateSeries([{ data }]);
            chart.updateOptions({
                tooltip: {
                    y: {
                        formatter: function (val, opts) {
                            return '';
                        },
                        title: {
                            formatter: function (seriesName, opts) {
                                return data[opts.dataPointIndex];
                            }
                        }
                    }
                }
            });
        },
        buscaTraducao(label) {
            if (label.includes('Não atribuído')) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.dashboard.naoAtribuido'
                );
            }
            return label;
        }
    }
};
</script>

<style lang="scss">
.container-menu-criterios {
    display: flex;
    gap: 10px;

    .bloco-menu-criterios {
        menu {
            padding: 0;
            display: flex;
            flex-direction: column;
            gap: 15px;

            li {
                width: 60px;
                height: 60px;
                padding: 0;
                margin: 0;
                list-style: none;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                border-radius: $default-border-radius;
                cursor: pointer;
                box-shadow: $default-shadow;

                i {
                    font-size: 30px;
                }

                i,
                span {
                    height: 25px;
                    line-height: 25px;
                }
            }
        }

        .active {
            background-color: var(--primary);
            color: $white;
        }

        .inactive {
            background-color: $white;
            color: var(--primary);
        }
    }
    .bloco-ranking {
        flex: 1;
        margin-top: 13px;
        height: 100%;

        .bloco-ranking__cabecalho-grafico {
            display: flex;
            gap: 20px;

            .criterio-selecionado {
                display: flex;
                align-items: center;
                width: 140px;

                label {
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
